import i18n from '@/plugins/i18n/locale';

/**
 * scriptタグが含まれていないかどうか検証する
 */
const isNotScriptTag: any = {
  validate: (value: any): boolean => {
    if (value == null || value === '') {
      return true;
    }
    if (typeof value !== 'string') {
      return false;
    }
    return notContains(value);
  },
  message: (field: string, values: any) => {
    values._field_ = `${i18n.t(`form.fields.${field}`)}`;
    return i18n.t(`validations.custom.${values._rule_}`, values);
  }
};

const notContains = (c: string): boolean => {
  const re = /<script[^>]+?\/>|<script(.|\s)*?\/script>/gi;
  return !re.test(c);
};

export default isNotScriptTag;
